import React, { createContext, useContext, useEffect, useState } from 'react'
import { authApi } from '../api/auth/authApi'
import { ToastContext } from './toastContext'
import { Spinner } from 'react-bootstrap'

export const AuthContext = createContext('')

const AuthContextProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null)
  const [userData, setUserData] = useState(null)
  const [showAuthModal, setShowAuthModal] = useState(false)
  const { setError } = useContext(ToastContext)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const session = localStorage.getItem('session')

    // Проверяем валидность токена при инициализации
    if (session && !/^[\x00-\x7F]*$/.test(session)) {
      localStorage.removeItem('session')
      setIsAuth(false)
      setUserData(null)
      setError('Невалидный формат токена')
      return
    }

    if (session) {
      authApi
        .verify()
        .then((res) => {
          if (res?.error_code !== 0) {
            setError(res.message)
            setIsAuth(false)
            setUserData(null)
            localStorage.removeItem('session')
          } else {
            setIsAuth(true)
            setUserData(res?.userdata || null)
          }
        })
        .catch(() => {
          setIsAuth(false)
          setUserData(null)
          setError('неизвестная ошибка')
          localStorage.removeItem('session')
        })
    } else {
      setIsAuth(false)
      setUserData(null)
    }
  }, [])

  const clearSessionAndShowAuth = () => {
    localStorage.removeItem('session')
    setIsAuth(false)
    setUserData(null)
    setShowAuthModal(true)
  }

  const value = {
    isAuth,
    setIsAuth,
    userData,
    setUserData,
    showAuthModal,
    setShowAuthModal,
    clearSessionAndShowAuth
  }

  return (
    <AuthContext.Provider value={value}>
      {isAuth === null ? (
        <div
          style={{
            height: '100vh',
            backgroundColor: '#0f0f0f',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Spinner
            style={{ width: '5rem', height: '5rem' }}
            animation="border"
            role="status"
            variant="light"
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  )
}
export default AuthContextProvider
